import React, { useMemo } from 'react';
import { Link, LinkProps, useSearchParams } from 'react-router-dom';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { Paths } from 'shared/routes';
import { UtmParameters } from 'shared/types/utm-parameters';
import { combineSearchParams } from 'shared/utils/combine-search-params';

import { getPathAllowedSearchParams } from '../get-global-allowed-search-parameters';

export type QueryNavLinkProps = LinkProps & {
  activeSearchParamsToIgnore?: (QueryParamOptions | UtmParameters)[];
};

export const QueryNavLink = React.forwardRef<
  HTMLAnchorElement,
  QueryNavLinkProps
>(({ to, activeSearchParamsToIgnore, ...rest }, ref) => {
  const [search] = useSearchParams();

  const processedTo = useMemo(() => {
    const toSearch =
      typeof to === 'object' ? to.search?.toString() : to.split('?')[1];
    const rest = typeof to === 'object' ? to : {};
    const pathname = typeof to === 'object' ? to.pathname : to.split('?')[0];

    const allowedSearchParams = getPathAllowedSearchParams(
      pathname as Paths,
      search,
      activeSearchParamsToIgnore,
    );

    const combinedSearch = combineSearchParams(
      allowedSearchParams,
      new URLSearchParams(toSearch),
    );

    return {
      ...rest,
      pathname,
      search: combinedSearch.toString(),
    };
  }, [activeSearchParamsToIgnore, search, to]);

  return <Link to={processedTo} {...rest} ref={ref} />;
});
